export { default, type TariffsInfoSectionProps, SECTION_ID as tariffsInfoSectionId } from './TariffsInfoSection';
export {
    default as TariffsInfoSectionWithPopup,
    type TariffsInfoSectionWithPopupProps,
    type TariffWithPopupItem,
    SECTION_ID as tariffsInfoSectionWithPopupId,
} from './TariffsInfoSectionWithPopup';
